import {
    DialogType,
    Dialog,
    DefaultButton,
    PrimaryButton,
} from "@fluentui/react";
import * as React from "react";
import PdfContent from "./PdfContent";
import LoanCarAgreement from "./loanCarAgreement";
import ReactSignatureCanvas from "react-signature-canvas";


const loanCarItems = ["BIL001"];
interface Props {
    order: Order;
}

const LoanCarHandler: React.FunctionComponent<Props> = props => {
    const [hidden, setHidden] = React.useState(true);
    const toggleHideDialog = () => setHidden(!hidden);    
    const [signatureDriver, setSignatureDriver] = React.useState<string | undefined>();
    const [signature, setSignature] = React.useState<string | undefined>();
     const [insuranced, setInsuranced] = React.useState<boolean>(false);
    const [driverLicense, setDriverLicense] = React.useState<string>("");
    const signatureCanvas = React.useRef(null);
    const maxWidth = 700;
   
    const [canvasSize, setCanvasSize] = React.useState({ width: 400, height: 55 });
    const [isSmallPortrait, setIsSmallPortrait] = React.useState(false);
    const aspectRatio = 55 / 400;
    
    const updateCanvasSize = () => {
    const isSmallPortraitValue = window.matchMedia("(max-width: 767px) and (orientation: portrait)").matches;
    setIsSmallPortrait(isSmallPortraitValue);
    const padding = 80;
    const availableWidth = isSmallPortraitValue
        ? window.innerHeight - padding
        : window.innerWidth - padding;

    const newWidth = Math.min(availableWidth, maxWidth);
    const newHeight = newWidth * aspectRatio;

    setCanvasSize({ width: newWidth, height: newHeight });
    };

   React.useEffect(() => {
        updateCanvasSize();
        window.addEventListener("resize", updateCanvasSize);
        return () => window.removeEventListener("resize", updateCanvasSize);
    }, []);

    const [isSignDocHidden, setIsSignDocHidden] = React.useState<"DRIVER" | "DISCLIAMER" | undefined>(undefined);
      const dialogContentProps = {
        type: DialogType.normal,
        title: "Låneaftale - Kundebil"
    };
    const hasLoanCar = props.order.items.find(x => loanCarItems.indexOf(x.itemNo) !== -1) !== undefined;
    if (!hasLoanCar) {
        return null;
    }

    const  toggleSignHideDialog = (value: "DRIVER" | "DISCLIAMER" | undefined) => () => setIsSignDocHidden(value);
    const onSignClick = async () => 
        {
            if( document.activeElement)
            {
                (document.activeElement as any).blur();

            }
            const signatureDataUrl = (signatureCanvas as any).current.getTrimmedCanvas().toDataURL("image/png");
            isSignDocHidden === "DRIVER" ? setSignatureDriver(signatureDataUrl) : setSignature(signatureDataUrl);
            setIsSignDocHidden(undefined);
        }
    const hasSignedLoanCar = props.order.orderProperties && props.order.orderProperties.signedLoanCar && props.order.orderProperties.loanCarId;
    
    return (
        <>
            <DefaultButton
                text={hasSignedLoanCar ? "Vis Låneaftale" : "Underskriv Låneaftale"}
                onClick={toggleHideDialog}
            />
            <Dialog key={1}
                firstFocusableSelector={undefined}
                hidden={hidden}
                dialogContentProps={dialogContentProps}
                onDismiss={toggleHideDialog}
                styles={{
                    main: {
                      width: `${hasSignedLoanCar ? 500 : 1000}px !important`,
                      maxWidth: 'calc(100vw - 32px) !important',
                      minWidth: '0 !important',
                    },
                  }}
                  
            >
                {hasSignedLoanCar && props.order.orderProperties ?
                    <LoanCarAgreement order={props.order} onDismiss={toggleHideDialog} />
                    :
                    <PdfContent 
                        order={props.order} 
                        onDismiss={toggleHideDialog} 
                        signatureDriver={signatureDriver}
                        signature={signature}
                        onShowSignDial={toggleSignHideDialog}
                        insuranced={insuranced}
                        setInsuranced={setInsuranced}
                        driverLicense={driverLicense}
                        setDriverLicense={setDriverLicense}
                    />
                }
            </Dialog>
            <Dialog key={2}
                hidden={isSignDocHidden === undefined}
                dialogContentProps={{ type: DialogType.normal, title: "Underskriv",}}
                onDismiss={toggleSignHideDialog(undefined)}
                firstFocusableSelector={"sigCanvas"}
                modalProps={{
                    className: 'sigModal', 
                }}
            >   
              {isSmallPortrait? 
               <span style={{ fontSize: 18, marginBottom: 10 }}>Rotere skærm for at underskrive </span>
               : 
                <>
                    <div style={{ width: "100%", display: "flex", marginBottom: 10, maxWidth: "100%", justifyContent: "center", }}>
                        <ReactSignatureCanvas
                            clearOnResize={true}
                            ref={signatureCanvas}
                            penColor="black"
                            canvasProps={{ width: canvasSize.width, height: canvasSize.height, className: "sigCanvas" }}
                        />
                    
                    </div>
                    <PrimaryButton onClick={onSignClick} text="Underskriv" />
                </>
            }


            </Dialog>
        </>
    );
};

export default LoanCarHandler;